import React from 'react';
import '../../scss/footer.scss';

const footer = () => {
    return (
        <div className='footer'>
            <div className='footer-left'>
                <span>Copyright &#169; {new Date().getUTCFullYear()} Clairvoyix. All rights reserved.</span>
            </div>
            {/* <div className='footer-right'>
                <span className='terms'>Terms & Conditions</span>
                <span className='privacy'>Privacy Policy</span>
            </div> */}
        </div>
    );
};

export default footer;